import { isLoggedIn } from 'utils/auth';

export default (store) => {
  return {
    path: "tenant-field-mapping",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const campaignDetailsV2 = require("./tenantFieldMapping").default;
          cb(null, campaignDetailsV2);
        },
        "tenantFieldMapping"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/TenantFieldMapping/index.js